import { SSORoutes } from '../router.types';

export const ssoRoutes: SSORoutes = {
  loginSSO: `${process.env.NEXT_PUBLIC_SSO_HOST}/start`,
  logoutSSO: `${process.env.NEXT_PUBLIC_SSO_HOST}/logout`,
};
